"use strict";
// R68 · `publicacion_scielo.pais_scielo` is NOT NULL and holds the SciELO collection's country,
// spelled the way the importer's dictionary writes it (`Chile`, `México`). The edit form only gets
// a link (or a bare PID), so the country comes from the collection's domain when there is one.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAIS_SCIELO_POR_DEFECTO = void 0;
exports.paisScieloDesdeLink = paisScieloDesdeLink;
exports.scieloPidDesdeLink = scieloPidDesdeLink;
/** SciELO collection, by the country-code TLD of its site (`www.scielo.org.mx` → `mx`). */
const PAIS_POR_TLD = {
    ar: 'Argentina',
    bo: 'Bolivia',
    br: 'Brasil',
    cl: 'Chile',
    co: 'Colombia',
    cr: 'Costa Rica',
    cu: 'Cuba',
    ec: 'Ecuador',
    es: 'España',
    mx: 'México',
    pe: 'Perú',
    pt: 'Portugal',
    py: 'Paraguay',
    uy: 'Uruguay',
    ve: 'Venezuela',
    za: 'Sudáfrica',
};
/**
 * Collections whose host does not end in their country's TLD. The importer (OpenAlex parser,
 * `_SCIELO_COUNTRIES`) maps by the FULL host, so these must be looked up before the TLD.
 */
const PAIS_POR_HOST = {
    've.scielo.org': 'Venezuela',
};
/** Fallback for a bare PID: the publications typed by hand at UDA come from `scielo.cl`. */
exports.PAIS_SCIELO_POR_DEFECTO = 'Chile';
/** Country of the SciELO collection a link points to; null if it is not a known SciELO URL. */
function paisScieloDesdeLink(link) {
    const v = link?.trim();
    if (!v)
        return null;
    let host;
    try {
        host = new URL(v).hostname.toLowerCase();
    }
    catch {
        return null;
    }
    if (!host.split('.').includes('scielo'))
        return null;
    const sinWww = host.replace(/^www\./, '');
    return PAIS_POR_HOST[sinWww] ?? PAIS_POR_TLD[host.split('.').pop() ?? ''] ?? null;
}
/** A SciELO PID: `S` + ISSN (9) + year (4) + 8 digits, e.g. `S0718-07642021000100003`. */
const PID_SCIELO = /S\d{4}-\d{3}[\dXx]\d{13}/;
/** The SciELO PID inside a link (`?pid=…` or anywhere in the URL); null when there is none. */
function scieloPidDesdeLink(link) {
    const v = link?.trim();
    if (!v)
        return null;
    try {
        const pid = new URL(v).searchParams.get('pid');
        if (pid && PID_SCIELO.test(pid))
            return pid.match(PID_SCIELO)[0];
    }
    catch {
        // Not a URL: still try the raw text below.
    }
    return v.match(PID_SCIELO)?.[0] ?? null;
}
